/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable import/no-cycle */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import Environments from "../../Environments";
import MOCK_DATA from "../../mock/data";
import { SompoContextValues } from "../context/SompoContext";

export interface UserIterface {
    layout: string;
    title: string;
    background?: string;
    agreement?: string;
    agreementContents?: string[];
}
export interface Menu {
    administrator?: boolean;
    search?: boolean;
    skill?: boolean;
    information?: boolean;
    user?: boolean;
}
export interface Company {
    menu: Menu;
    ui: UserIterface;
}

const COMPANY_CODE_DEFAULT = "default";
const IMAGE_NONE = "none";

export const LAYOUT_PATTERN_1 = "1";
export const LAYOUT_PATTERN_2 = "2";
export const LAYOUT_PATTERN_3 = "3";

const fetchSettings = async (companyCode: string, ignoreError = true): Promise<Company> => {
    if (Environments.MOCK) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(MOCK_DATA.COMPANIES[companyCode]);
            }, 500);
        });
    }

    if (!companyCode) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({} as Company);
            }, 500);
        });
    }

    return fetch(`./companies/${companyCode}/setting.json`, {
        method: "GET",
        headers: [
            ["Content-Type", "application/json;charset=UTF-8"],
            ["Cache-Control", "no-cache"],
        ],
    })
        .then((response: Response) => {
            const json = response.json();
            return json as unknown as Company;
        })
        .catch((error: any) => {
            if (ignoreError) return {} as Company;
            throw error;
        });
};

const nvl = <T>(target: any, value: T, defaultValue: T) => {
    return target ? value : defaultValue;
};

const getDir = (value: any, companyCode: string) => {
    return nvl(value, companyCode, COMPANY_CODE_DEFAULT);
};

const getFile = (dir: string, name: string) => {
    return `./companies/${dir}/${name}`;
};

const getTitle = (companyCode: string, defaultSettings: Company, companySettings: Company): string => {
    const defaultTitle = defaultSettings?.ui?.title;
    // console.log("title:default", defaultBG);

    const companyTitle = companySettings?.ui?.title;
    // console.log("title:company", companyBG);

    const customized = companyTitle !== undefined;
    const dir = getDir(customized, companyCode);
    const file = nvl(customized, companyTitle, defaultTitle);
    const background = file !== IMAGE_NONE ? getFile(dir, file) : "";
    // console.log("title", background);
    return background;
};

const getBackground = (companyCode: string, defaultSettings: Company, companySettings: Company): string => {
    const defaultBG = defaultSettings?.ui?.background;
    // console.log("background:default", defaultBG);

    const companyBG = companySettings?.ui?.background;
    // console.log("background:company", companyBG);

    const customized = companyBG !== undefined;
    const dir = getDir(customized, companyCode);
    const file = nvl(customized, companyBG, defaultBG);
    const background = file !== IMAGE_NONE ? getFile(dir, file!) : "";
    // console.log("background", background);
    return background;
};

const getAgreement = async (companyCode: string, defaultSettings: Company, companySettings: Company): Promise<[string, string[]]> => {
    const defaultAgreement = defaultSettings?.ui?.agreement;
    // console.log("agreement:default", defaultAgreement);

    const companyAgreement = companySettings?.ui?.agreement;
    // console.log("agreement:company", companyAgreement);

    const agreementCustomized = companyAgreement !== undefined;
    const agreementDir = getDir(agreementCustomized, companyCode);
    const agreementFile = agreementCustomized ? companyAgreement : defaultAgreement;
    const file = getFile(agreementDir, agreementFile!);
    // console.log("agreement", file);

    if (Environments.MOCK) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(["agreement.txt", MOCK_DATA.COMPANIES[companyCode].ui.agreementContents!]);
            }, 500);
        });
    }

    const contents = await fetch(file, {
        method: "GET",
        headers: [
            ["Content-Type", "text/plain;charset=UTF-8"],
            ["Cache-Control", "no-cache"],
        ],
    })
        .then(async (response: Response) => {
            const text = await response.text();
            return text;
        })
        .catch((error: any) => {
            throw error;
        });

    return [file, contents.split("\n")];
};

export const fetchCompanySettings = async (companyCode: string): Promise<Company> => {
    const defaultSettings = await fetchSettings(COMPANY_CODE_DEFAULT);
    // console.log(defaultSettings);

    const companySettings = await fetchSettings(companyCode, true);
    // console.log(companySettings);

    const defaultUI: UserIterface | undefined = defaultSettings.ui;
    const companyUI: UserIterface | undefined = companySettings.ui;

    // タイトル画像
    const title = getTitle(companyCode, defaultSettings, companySettings);

    // ヘッダ背景
    const background = getBackground(companyCode, defaultSettings, companySettings);

    // 利用規約
    const [agreement, agreementContents] = await getAgreement(companyCode, defaultSettings, companySettings);

    return {
        menu: Object.assign(defaultSettings.menu, companySettings.menu),
        ui: {
            layout: companyUI?.layout || defaultUI?.layout,
            title,
            background,
            agreement,
            agreementContents,
        },
    };
};

const getCompanySettings = () => SompoContextValues.companySettings;

const getUISettings = () => getCompanySettings().ui;

const getCssImageURL = (image: string) => {
    return `url(${image})`;
};

export const getLayout = (): string => {
    return getUISettings().layout;
};

export const getHeaderTitle = (): string => {
    return getUISettings().title;
};

export const getHeaderBackground = (): string => {
    const { background } = getUISettings();
    return background ? getCssImageURL(background) : "";
};

const getMenuSettings = () => getCompanySettings().menu;

export const showSearchMenu = () => {
    const show = getMenuSettings().search;
    return show !== undefined ? show : true;
};

export const showSkillMenu = () => {
    const show = getMenuSettings().skill;
    return show !== undefined ? show : true;
};

export const showAdministratorMenu = () => {
    const show = getMenuSettings().administrator;
    return show !== undefined ? show : true;
};

export const showInformationMenu = () => {
    const show = getMenuSettings().information;
    return show !== undefined ? show : true;
};

export const showUserMenu = () => {
    const show = getMenuSettings().user;
    return show !== undefined ? show : true;
};
